import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  isWideScreen: boolean;
  sidebarOpen: boolean;
  theme: 'light' | 'dark';
  loading: {
    [key: string]: boolean;
  };
  /** Recently visited page paths, most recent first. */
  recentPages: string[];
}

const MAX_RECENT_PAGES = 20;

const initialState: UIState = {
  isWideScreen: window.innerWidth > 900,
  sidebarOpen: true,
  theme: 'light',
  loading: {},
  recentPages: [],
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setIsWideScreen: (state, action: PayloadAction<boolean>) => {
      state.isWideScreen = action.payload;
      // Auto-close sidebar on mobile
      if (!action.payload) {
        state.sidebarOpen = false;
      }
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload;
    },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload;
    },
    toggleTheme: (state) => {
      state.theme = state.theme === 'light' ? 'dark' : 'light';
    },
    setLoading: (state, action: PayloadAction<{ key: string; loading: boolean }>) => {
      state.loading[action.payload.key] = action.payload.loading;
    },
    recordPageVisit: (state, action: PayloadAction<string>) => {
      const path = action.payload;
      state.recentPages = [path, ...(state.recentPages ?? []).filter((p) => p !== path)].slice(
        0,
        MAX_RECENT_PAGES,
      );
    },
  },
});

export const {
  setIsWideScreen,
  toggleSidebar,
  setSidebarOpen,
  setTheme,
  toggleTheme,
  setLoading,
  recordPageVisit,
} = uiSlice.actions;

export default uiSlice.reducer;